import React, {useState} from "react";
import DeleteButton from "../buttons/DeleteButton";
import {useDispatch, useSelector} from "react-redux";
import {deleteOneSwotItem} from "./one-swot-item/SwotItemAction";
import YesNoModal from "../modal/YesNoModal";
import {loadOneAxis} from "../axis/one-axis/oneAxisAction";
import styled from "styled-components";
import TextAreaCard from "./TextAreaCard";
import {loadProject} from "../project/one-project/projectAction";
import {loadStrategy} from "../strategy/strategyAction";
import {sliceText} from "../../utils/utils";

const SwotCard = ({content, id, entity, canBeEdited, fromCoach}) => {

    const dispatch = useDispatch()
    const {id : axisId} = useSelector(state => state.oneAxis)
    const projectId = useSelector(state => state.project.id)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [formOpen, setFormOpen] = useState(false)

    const setUpdateCard = (e) => {
        if (e.target.tagName === "svg") {
            setOpenDeleteModal(true)
        } else {
            setFormOpen(true)
        }
    }

    const deleteRequest = async (id) => {
        await dispatch(deleteOneSwotItem(id))
        if (entity === "axis") {
            dispatch(loadOneAxis(axisId))
        }
        if (entity === 'project') {
            dispatch(loadProject(projectId))
        }
        if (entity === "strategy") {
            dispatch(loadStrategy())
        }
        setFormOpen(false)
        setOpenDeleteModal(false)
    }


    return (
        <>
            {formOpen ?
                <TextAreaCard setFormOpen={setFormOpen} content={content} id={id} entity={entity}/>
                :
                <Card onClick={canBeEdited ? setUpdateCard : null}>
                    <p> {fromCoach ? sliceText(content, 60) : content} </p>
                    {canBeEdited &&
                    <DeleteButton
                        setOpenDeleteModal={setOpenDeleteModal}
                    />
                    }
                </Card>
            }
            {openDeleteModal &&
            <YesNoModal
                setOpenModal={setOpenDeleteModal}
                name={'cette carte'}
                id={id}
                handleClickYesAction={deleteRequest}
            />
            }
        </>

    )
}

const Card = styled.div`
  background-color: var(--color-white);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  min-height: 20px;
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  min-width: 100%;
  

  &:hover {
    background-color: var(--color-purple-lighten);
    cursor: pointer;
  }
`


export default SwotCard;